// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#pause-until-datepicker__dialog_ .btn-light {\n  background-color: white;\n}\n", ""]);
// Exports
module.exports = exports;
